var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-list container"},[_c('img',{staticClass:"img",attrs:{"src":require("../asset/component/list/list.png"),"alt":""}})])
}]

export { render, staticRenderFns }